import { defer, noop } from "rxjs";
import { tap } from "rxjs/operators";
export function tapWithIndex(nextOrObserver, error, complete) {
    return (source) => defer(() => {
        let index = -1;
        let context;
        let handleNext;
        let handleError;
        let handleComplete;
        if (nextOrObserver && typeof nextOrObserver !== "function") {
            context = nextOrObserver;
            handleNext = nextOrObserver.next || noop;
            handleError = nextOrObserver.error || noop;
            handleComplete = nextOrObserver.complete || noop;
        }
        else {
            context = undefined;
            handleNext = nextOrObserver || noop;
            handleError = error || noop;
            handleComplete = complete || noop;
        }
        return source.pipe(tap((value) => handleNext.call(context, [value, ++index]), (error) => handleError.call(context, error), () => handleComplete.call(context)));
    });
}
//# sourceMappingURL=tapWithIndex.js.map